/**
 *
 * @module playlist
 *
 */

/**
 *
 * @class Playlist
 * @since 2.0.0
 * @desc The stream URI and metadata about which playlist stream was picked for
 * playback (in the case of requesting one playlistType and getting another that is available).
 *
 */
export default class Playlist {

    /**
     *
     * @param {String} streamUri
     * @param {PlaylistType} playlistType
     * @param {Array<PlaylistType>} availablePlaylistTypes
     * @param {PlaybackAttributes} attributes
     *
     */
    constructor(streamUri, playlistType, availablePlaylistTypes, attributes) {

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.streamUri = streamUri;

        /**
         *
         * @access public
         * @type {PlaylistType}
         *
         */
        this.playlistType = playlistType;

        /**
         *
         * @access public
         * @type {Array<PlaylistType>}
         *
         */
        this.availablePlaylistTypes = availablePlaylistTypes;

        /**
         *
         * @access public
         * @since 3.2.0
         * @type {PlaybackAttributes}
         * @desc Gets the attributes of the stream.
         *
         */
        this.attributes = attributes;

    }

}



// WEBPACK FOOTER //
// ./src/media/playlist.js